var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAutoSchwarz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.03 24.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg4993"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5855",
    d: "M26.18,24.57a1.32,1.32,0,0,1-1.2-.9,31.65,31.65,0,0,1-.12-4.91c.06-.11-.06-.11-8.89-.11-7,0-8.93,0-8.88.07a38.67,38.67,0,0,1,0,4.61,1.39,1.39,0,0,1-.61,1l-.26.18-1.65,0c-1.89,0-1.87,0-2.37-.5l-.31-.33V21.29A10.72,10.72,0,0,1,2,18.73c.09-.13.08-.13-.22-.17A2.09,2.09,0,0,1,.24,17.33c-.15-.33-.16-.4-.21-2,0-1.07,0-2.15,0-3.05.07-1.62.05-1.56.74-2.64A43,43,0,0,0,3.61,3.73C4.82,1,5.09.55,5.84.21A4.91,4.91,0,0,1,7.53,0c1.83,0,15.11-.06,17,0,1.35,0,1.44.06,1.76.21C27,.58,27.25,1,29,5.09a26.83,26.83,0,0,0,2.12,4.36A3.59,3.59,0,0,1,32,11.84c.07,1.15.07,3.33,0,4.34A2.22,2.22,0,0,1,31.37,18a1.54,1.54,0,0,1-1.13.6c-.3.05-.31.06-.22.15s.09.42.09,2.56v2.46l-.34.38a3,3,0,0,1-.5.44,19.92,19.92,0,0,1-3.08,0ZM5.19,14.3a1.76,1.76,0,0,0,1-2.18,2.06,2.06,0,0,0-1-1.07,2.66,2.66,0,0,0-1,0,1.74,1.74,0,1,0,1.1,3.29Zm22.91,0a1.81,1.81,0,0,0,1.07-1.14A1.71,1.71,0,0,0,27.48,11a1.57,1.57,0,0,0-1.28.58,1.75,1.75,0,0,0,.52,2.7,1,1,0,0,0,.66.17A3.21,3.21,0,0,0,28.1,14.32Zm-3-6.23,2.19,0-.64-1.48C26,5,25.06,2.9,25,2.84S13,2.73,9.73,2.77l-2.65,0-.37.72c-.27.55-1.79,3.94-2,4.48a7.69,7.69,0,0,0,2.07.1c4.2,0,16.23,0,18.36,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAutoSchwarz);
export default __webpack_public_path__ + "static/media/icon_auto_schwarz.bf25a60dca0ec0e6fdba9d5d22611667.svg";
export { ForwardRef as ReactComponent };